import Vue from 'vue';

import * as types from './mutation-types';

const mutations = {
  [types.SET_SHARED_PAGE_INFO](state, data) {
    Vue.set(state, 'sharedPageInfo', data);
  },

  [types.SET_SHARED_PAGE](state, data) {
    Vue.set(state, 'sharedPage', data);
  },

  [types.SET_SHARED_PAGE_RESULTS](state, data) {
    Vue.set(state, 'sharedPageResults', data);
  },

  [types.SET_SHARED_QUIZ_OPTION](state, data) {
    Vue.set(state, 'selectedOption', data);
  },
};

export default mutations;
